import React from 'react';
import { cardClass } from '@app/constants/styles';

// Their own module, not the dashboard's, so a tab uses them without pulling its data hooks in.

export const Card = ({ children, className }: { children: React.ReactNode; className?: string }): JSX.Element => (
  <div className={`break-inside-avoid ${cardClass} ${className ?? ''}`}>{children}</div>
);
